<!-- VIEW MODE -->
<div *ngIf="!isEditing; else editMode" class="flex-grow-1 border rounded-2 d-flex justify-content-between align-items-center p-3">
  <div class="d-flex justify-content-between col-lg-8 gap-3">
    <span>{{ name }}:</span>
    <span class="col-lg-9">{{ value }}</span>
  </div>
  <div class="d-flex align-items-center col-lg-4 justify-content-end">
    <button
      class="d-flex align-items-center gap-2 col-lg-4 justify-content-end cursor-pointer btn edit-button w-40 justify-content-center"
      (click)="startEdit()">
      <mat-icon
        class="text-primary fs-3 d-flex align-items-center justify-content-center"
        style="overflow: visible"
      >edit
      </mat-icon>
      <span class="text-primary personal-information-edit-icon">Edit</span>
    </button>
  </div>
</div>

<!-- EDIT MODE -->
<ng-template #editMode>
  <div class="border rounded-2 p-3">

    <ng-container *ngIf="!isSpecificForm; else specificForms"
                  [ngTemplateOutlet]="!isSpecificForm ? otherForms : specificForms">
    </ng-container>

    <ng-template #specificForms>
      <ng-container *ngIf="type === PersonalInformationEditCardType.PHONE"
                    [ngTemplateOutlet]="phoneForm"></ng-container>
      <ng-container *ngIf="type === PersonalInformationEditCardType.PASSWORD"
                    [ngTemplateOutlet]="passwordForm"></ng-container>
    </ng-template>

    <div class="d-flex gap-3 justify-content-end mt-4">
      <button type="button"
              class="btn btn-outline-secondary rounded-pill px-4"
              (click)="cancelEdit()">
        Cancel
      </button>
      <button type="button"
              class="btn btn-primary rounded-pill px-4"
              (click)="saveChanges()">
        Save Changes
      </button>
    </div>
  </div>
</ng-template>

<!-- FORMS -->
<ng-template #otherForms>
  <div class="row gy-3">
    <form [formGroup]="formGroup" class="d-flex flex-column gap-2">
      <div class="col-md-12 d-flex align-items-start" *ngFor="let formControl of getControlsByType()">
        <label class="col-md-3 col-form-label text-dark">{{ formatLabel(formControl) }}</label>
        <div class="col-md-9">
          <input type="text"
                 class="form-control rounded-3 border-0 px-3 py-2 bg-light-subtle"
                 [placeholder]="getPlaceholderByFormControl(formControl)"
                 [formControl]="castToFormControl(formControl)">
        </div>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #passwordForm>
  <div class="row gy-3">
    <form [formGroup]="formGroup" class="d-flex flex-column gap-2">
      <div class="col-md-12 d-flex align-items-start">
        <label class="col-md-3 col-form-label text-dark">Old Password</label>
        <div class="col-md-9">
          <input type="text"
                 placeholder="Enter old password"
                 class="form-control rounded-3 border-0 px-3 py-2 bg-light-subtle"
                 [value]="oldPassword">
        </div>
      </div>
      <div class="col-md-12 d-flex align-items-start">
        <label class="col-md-3 col-form-label text-dark">New Password</label>
        <div class="col-md-9">
          <input type="text"
                 placeholder="Enter new password"
                 class="form-control rounded-3 border-0 px-3 py-2 bg-light-subtle"
                 [formControlName]="'password'">
        </div>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #phoneForm>
  <div class="row gy-3">
    <form [formGroup]="formGroup" class="d-flex flex-column gap-2">
      <div class="col-md-12 d-flex align-items-start">
        <label class="col-md-3 col-form-label text-dark">Phone</label>
        <div class="col-md-9">
          <input type="text"
                 placeholder="Enter phone number"
                 class="form-control rounded-3 border-0 px-3 py-2 bg-light-subtle"
                 [formControlName]="'phone'">
        </div>
      </div>
    </form>
  </div>
</ng-template>
